import { MeasurementType } from "../enums/Result";
import { WaveformScalingFactors } from "../interfaces/Result";

export interface WaveformConstantValues extends WaveformScalingFactors {
  XAxisUnitTranslationKey: string;
  YAxisUnitTranslationKey: string;
}

export default class UTP2WaveformConstants {
  static getWaveformConstants = (
    measurementType: MeasurementType,
    waveformScalingFactors?: WaveformScalingFactors,
  ): WaveformConstantValues => {
    if (!waveformScalingFactors) {
      return UTP2WaveformConstants.getDefaultValues();
    }

    switch (measurementType) {
      case MeasurementType.CablePD: {
        return UTP2WaveformConstants.getCablePDValues(waveformScalingFactors);
      }
      case MeasurementType.TEV: {
        return UTP2WaveformConstants.getTEVValues(waveformScalingFactors);
      }
      case MeasurementType.UHF: {
        return UTP2WaveformConstants.getUHFValues(waveformScalingFactors);
      }
      case MeasurementType.Ultra: {
        //Note: ULTRASONIC - there doesn't appear to be waveform data for ultrasonic measurements
        return UTP2WaveformConstants.getDefaultValues();
      }
      case MeasurementType.VPIS: {
        return UTP2WaveformConstants.getVPISValues(waveformScalingFactors);
      }
      default: {
        return UTP2WaveformConstants.getDefaultValues();
      }
    }
  };

  private static getDefaultValues = (): WaveformConstantValues => {
    return {
      Scale: 1,
      Offset: 0,
      XStart: 0,
      Interval: 1,
      XAxisUnitTranslationKey: "",
      YAxisUnitTranslationKey: "",
    };
  };

  private static getCablePDValues = (waveformScalingFactors: WaveformScalingFactors): WaveformConstantValues => {
    return {
      ...waveformScalingFactors,
      XAxisUnitTranslationKey: "units.microseconds",
      YAxisUnitTranslationKey: "units.ma",
    };
  };

  private static getTEVValues = (waveformScalingFactors: WaveformScalingFactors): WaveformConstantValues => {
    return {
      ...waveformScalingFactors,
      XAxisUnitTranslationKey: "units.microseconds",
      YAxisUnitTranslationKey: "units.db",
    };
  };

  private static getUHFValues = (waveformScalingFactors: WaveformScalingFactors): WaveformConstantValues => {
    return {
      ...waveformScalingFactors,
      XAxisUnitTranslationKey: "units.microseconds",
      YAxisUnitTranslationKey: "units.dbm",
    };
  };

  private static getVPISValues = (waveformScalingFactors: WaveformScalingFactors): WaveformConstantValues => {
    return {
      ...waveformScalingFactors,
      XAxisUnitTranslationKey: "units.microseconds",
      YAxisUnitTranslationKey: "units.mV",
    };
  };
}
